exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n.scroll-container .el-scrollbar__bar {\n  bottom: 0px;\n}\n.scroll-container .el-scrollbar__wrap {\n  height: 49px;\n}", ""]);

// Exports
exports.locals = {
	"menuBg": "#304156",
	"menuText": "#bfcbd9",
	"menuActiveText": "#efefef"
};